import { Component, OnInit, Input, EventEmitter, Output, Renderer2, Inject, ElementRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/switchMap';
import { userTypes } from '../../login/login.config';
import { Iceutility } from '../../services/iceutility';
import { IcecontrolSettings, iceColumnDefinition, IcecontrolPermission } from '../../components/models/icesettings';
import { IcepanelComponent } from '../icepanel/icepanel.component';
import { IcematgridComponent } from '../icepanel/icematgrid.component';

@Component({
  selector: 'iceautocomplete',
  templateUrl: './iceautocomplete.component.html',
  styleUrls: ['./iceautocomplete.component.css'],
  providers: [IcematgridComponent]
})
export class IceautocompleteComponent implements OnInit {

  @Input() autoSettings: IcecontrolSettings = null;
  autoControl = new FormControl();
  filteredOptions: Observable<any[]>;

  @Input() placeholder: string = "";
  @Input() id: string = "";
  @Input() items: string = "";
  @Input() properties: any = {};
  @Output() InputChanged: EventEmitter<any> = new EventEmitter<any>();
  @Output() autocompleteChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() autocompleteQuery: EventEmitter<any> = new EventEmitter<any>();
  @Input() tableColumn: iceColumnDefinition = null;
  @Input() tableRowData: any = null;

  selected: any[] = [];
  showInputBox: boolean = true;

  // Data Members
  iceFormControl: FormControl = null;
  permission: IcecontrolPermission = null;
  userAccess = userTypes.USER_FEATURE_ACCESS;

  @ViewChild('elemInput') elemInput!: ElementRef;

  constructor(@Inject(IcepanelComponent) private parent: IcepanelComponent,
    @Inject(IcematgridComponent) private parentTable: IcematgridComponent) {
  }

  ngOnInit() {
    try {
      this.permission = this.autoSettings.permissions ? this.autoSettings.permissions : new IcecontrolPermission(userTypes.USER_FEATURES.ufNone, userTypes.USER_FEATURE_ACCESS.ufaNone);
      if (Iceutility.isdefined(this.autoSettings) && Iceutility.isdefined(this.autoSettings.properties)) {
        this.properties = this.autoSettings.properties;
        this.placeholder = this.autoSettings.placeholder;
      }

      if (this.autoSettings == null) {
        this.iceFormControl = new FormControl(''); // No control so we create a placeholder control to prevent an errors
      }
      else {
        if (this.parentTable && this.tableRowData != null && this.tableColumn != null) {
          // tables should not use the standard formcontrol
          let formRowGroup: FormGroup = this.parentTable.getFormGroup(this.tableRowData);
          this.iceFormControl = new FormControl(this.tableRowData[this.tableColumn.columnName]);
          formRowGroup.addControl(this.tableColumn.columnName, this.iceFormControl);
        }
        else {
          this.iceFormControl = this.autoSettings.getFormControl();
          if (this.iceFormControl == null)
            this.iceFormControl = new FormControl(''); // No control so we create a placeholder control to prevent an errors
        }
      }

      if (this.permission.default_access === userTypes.USER_FEATURE_ACCESS.ufaReadOnly) {
        this.autoControl.disable();
      }
      if (this.iceFormControl != null && this.iceFormControl.value != null && this.iceFormControl.value.length > 0) {
        try {
          let sel = JSON.parse(this.iceFormControl.value);
          if (this.autoSettings != null && sel != null && sel.length > 0)
            this.autoSettings.setMultipleSelection(true);

          this.setSelected(sel);
        }
        catch (e) {
          this.setSelected([]);
          console.log(e);
        }
      }

      if (this.iceFormControl != null) {
        this.iceFormControl.valueChanges.subscribe(
          val => {
            let newsel = [];
            if (val != null && val.length > 0) {
              try {
                newsel = JSON.parse(val);
              }
              catch (e) {
                console.log(e);
              }
            }
            this.setSelected(newsel);
            this.updateShowInputBoxFlag();
          },
          err => {
            console.log(JSON.stringify(err));
          }
        );
      }

      this.filteredOptions = this.autoControl.valueChanges
        .startWith('')
        .map(value => this._filter(value));
      this.autoSettings.optionAutoCompleteFormControl = this.autoControl;
      this.updateShowInputBoxFlag();
    }
    catch (e) {
      console.log(e);
    }
  }

  private getFilteredOptions(): Observable<any[]> {
    return this.filteredOptions;
  }

  private _filter(value: string): any[] {
    if (this.autoSettings == null) return [];
    if (Iceutility.isStringUndefinedNullOrEmpty(value)) return this.autoSettings.getOptions();
    const filtervalue = typeof value === "number" ? value : value.toLowerCase();

    setTimeout(() => {
      let evt: Event = new Event("autoComplete");
      evt["autocompleteQuerySettings"] = this.autoSettings;
      evt["value"] = value;
      if (this.parent && (this.parent.sections != null && this.parent.sections.length > 0) && this.parent.controlChange)
        this.parent.onControlChange(evt);
      else
        this.autocompleteQuery.emit(evt);
    });

    if (typeof value === "number")
      return this.autoSettings.getOptions().filter(option => (option["name"] != null && option["name"].toLowerCase().includes(filtervalue.toString())) || (option["value"] != null && option["value"] == filtervalue));

    return this.autoSettings.getOptions().filter(option => (option["name"] != null && option["name"].toLowerCase().includes(filtervalue)) || (option["value"] != null && option["value"].toLowerCase().includes(filtervalue)));
  }

  OnSelChange(event) {
    // verify if the item is already selected
    let isAlreadySelected = this.selected.find(s => s.name === event.source.viewValue && s.value === event.source.value);
    if (!isAlreadySelected) {
      this.selected.push({ name: event.source.viewValue, value: event.source.value });
      this.updateShowInputBoxFlag();
      this.iceFormControl.setValue(this.getSelectedValue());

      event.autocompleteSettings = this.autoSettings;
      if (this.tableRowData != null && this.tableColumn != null && this.parent) {
        this.tableRowData[this.tableColumn.columnName] = this.iceFormControl.value;
        event.tableColumn = this.tableColumn;
        event.tableRowData = this.tableRowData;

        this.parent.onControlChange(event);
      }
      else if (this.parent && (this.parent.sections != null && this.parent.sections.length > 0) && this.parent.controlChange)
        this.parent.onControlChange(event);
      else
        this.autocompleteChange.emit(event);

      // emit to control observers
      if (this.autoSettings.getChangeControlEvent() != null) {
        this.autoSettings.getChangeControlEvent().emit(event);
      }
    }
    this.autoControl.setValue('');
  }

  getOptionValue(opt: any): any {
    if (opt == null || opt.value == null) return "";

    return opt.value;
  }

  addItem($event): void {
    if (this.isReadonly()) return;
    this.autoControl.setValue('');
    this.showInputBox = true;
    setTimeout(() => {
      let inElem = this.elemInput.nativeElement;
      if(inElem) inElem.focus();
    });
  }

  removeItem(val) {
    if (this.isReadonly()) return;
    let keepSelected = [];
    if (Iceutility.isstring(val))
      keepSelected = this.selected.filter(item => item.value.toLowerCase() != val.toLowerCase())
    else
      keepSelected = this.selected.filter(item => item.value != val)

    this.setSelected(keepSelected);
    this.updateShowInputBoxFlag();
    this.autoControl.setValue('');
    this.iceFormControl.setValue(this.getSelectedValue());
    if (keepSelected.length == 0) {
      setTimeout(() => {
        let inElem = this.elemInput.nativeElement;
        if (inElem) inElem.focus();
      });
    }
    event["autocompleteRemoveSettings"] = this.autoSettings;
    if (this.tableRowData != null && this.tableColumn != null && this.parent) {
      this.tableRowData[this.tableColumn.columnName] = this.iceFormControl.value;
      event["tableColumn"] = this.tableColumn;
      event["tableRowData"] = this.tableRowData;

      this.parent.onControlChange(event);
    }
    else if (this.parent && (this.parent.sections != null && this.parent.sections.length > 0) && this.parent.controlChange)
      this.parent.onControlChange(event);
    else
      this.autocompleteChange.emit(event);

  }

  getSelectedValue(): string {
    return JSON.stringify(this.selected);
  }

  getSelected(): any[] {
    return this.selected;
  }

  setSelected(newSels: any[]): void {
    this.selected = newSels;
  }
  updateShowInputBoxFlag(): void {
    let show: boolean = false;
    if (this.selected == null || this.selected.length == 0) {
      show = true;
    }

    this.showInputBox = show;
  }

  isReadonly(): boolean {
    if (this.autoSettings == null) return false;

    return this.autoSettings.getReadonly();
  }

  showAddButton(): boolean {
    let show: boolean = false;
    if (this.selected && this.selected.length > 0 && this.autoSettings && this.autoSettings.getMultipleSelection() ) {
      show = true;
    }

    return show;
  }
}
